import { connect } from 'react-redux';

import { selectIsOfferPageRedesign } from 'shared/selectors';

import { ISimilarNewObjectsProps, SimilarNewObjects } from './index';
import { IState } from '../../store';
import { getPageEBC } from '../../utils/tracking/get_page_ebc';
import { getUserEBC } from '../../utils/tracking/get_user_ebc';

function mapStateToProps(state: IState): ISimilarNewObjectsProps {
  return {
    similarNewObjects: state.offerData.similarNewObjects,
    agent: state.offerData.agent,
    offer: state.offerData.offer,
    user: getUserEBC(state.offerData.user, state.abGroup),
    page: getPageEBC(state.offerData.offer.id, state.offerData.breadcrumbs),
    isRedesignPage: selectIsOfferPageRedesign(state),
  };
}

export const SimilarNewObjectsContainer = connect<ISimilarNewObjectsProps, {}, {}>(mapStateToProps)(SimilarNewObjects);
